<template>
  <MenuButton
    v-tooltip.bottom="'Filter'"
    class="flex rounded transition hover:bg-gray-200"
    :class="[
      small ? 'p-1' : 'p-2',
      open ? 'bg-gray-200' : '',
      {
        'bg-gray-200 md:hover:!bg-gray-300': isActive,
      },
    ]"
    title="Filter"
    aria-label="Filter"
  >
    <FilterMenuIcon
      aria-hidden="true"
      :class="[small ? 'h-[14px] w-[14px]' : 'h-5 w-5']"
    />
  </MenuButton>
</template>

<script lang="ts" setup>
interface Props {
  open: boolean;
  small: boolean;
  isActive: boolean;
}

defineProps<Props>();
</script>
